import pipe from "ramda/src/pipe"

import { safe } from "./fn"
import { isDateValid } from "./date"
import * as Mask from "services/utils/mask"
import _isEmpty from "lodash/isEmpty"

export function validarCNPJCPF(document) {
  if (!document) return null
  if (document.length === 11) {
    return validarCPF(document)
  }
  return validarCNPJ(document)
}

function validarCPF(cpf) {
  if (
    cpf.length !== 11 ||
    cpf === "00000000000" ||
    cpf === "11111111111" ||
    cpf === "22222222222" ||
    cpf === "33333333333" ||
    cpf === "44444444444" ||
    cpf === "55555555555" ||
    cpf === "66666666666" ||
    cpf === "77777777777" ||
    cpf === "88888888888" ||
    cpf === "99999999999"
  )
    return false
  let add = 0
  for (var i = 0; i < 9; i++) add += parseInt(cpf.charAt(i), 10) * (10 - i)
  let rev = 11 - (add % 11)
  if (rev === 10 || rev === 11) rev = 0
  if (rev !== parseInt(cpf.charAt(9), 10)) return false
  add = 0
  for (i = 0; i < 10; i++) add += parseInt(cpf.charAt(i), 10) * (11 - i)
  rev = 11 - (add % 11)
  if (rev === 10 || rev === 11) rev = 0
  if (rev !== parseInt(cpf.charAt(10), 10)) return false
  // alert('O CPF INFORMADO É VÁLIDO.');
  return true
}

export function validarCNPJ(cnpj) {
  if (cnpj !== undefined && cnpj !== "") {
    cnpj = cnpj.replace(/[^\d]+/g, "")

    if (cnpj === "") return false

    if (cnpj.length !== 14) return false

    // LINHA 10 - Elimina CNPJs invalidos conhecidos
    if (
      cnpj === "00000000000000" ||
      cnpj === "11111111111111" ||
      cnpj === "22222222222222" ||
      cnpj === "33333333333333" ||
      cnpj === "44444444444444" ||
      cnpj === "55555555555555" ||
      cnpj === "66666666666666" ||
      cnpj === "77777777777777" ||
      cnpj === "88888888888888" ||
      cnpj === "99999999999999"
    )
      return false // LINHA 21

    // Valida DVs LINHA 23 -
    let tamanho = cnpj.length - 2
    let numeros = cnpj.substring(0, tamanho)
    const digitos = cnpj.substring(tamanho)
    let soma = 0
    let pos = tamanho - 7
    for (var i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--
      if (pos < 2) pos = 9
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
    if (`${resultado}` !== digitos.charAt(0)) return false

    tamanho = tamanho + 1
    numeros = cnpj.substring(0, tamanho)
    soma = 0
    pos = tamanho - 7
    for (i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--
      if (pos < 2) pos = 9
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
    if (`${resultado}` !== digitos.charAt(1)) return false // LINHA 49

    return true // LINHA 51
  }
}

// -----------------------------------------------------------------------------

function usernameValidation(val) {
  return (
    /[a-zA-Z]/.test(val) && /[0-9]/.test(val) && /^(?=.*[A-Z]).+$/.test(val)
  )
}

function brazilianDateValidation(value) {
  return /^\d{2}\/\d{2}\/\d{4}$/.test(value) && isDateValid(value)
}

function timeValidation(time) {
  time = time.replace(/[^\d]+/g, "")
  const hour = time.substring(0, 2)
  if (parseInt(hour, 10) > 24) {
    return false
  }
  const minutes = time.substring(2, 4)
  if (parseInt(minutes, 10) > 59) {
    return false
  }
  return true
}

function isEqualPhoneValidation(n1, n2) {
  function stripX9(phone) {
    const regex = /^(\d{2})9(\d{8})$/
    return `${phone}`.replace(regex, "$1$2")
  }

  function isEqualX9(n1, n2) {
    const min = Math.min(n1, n2)
    const max = Math.max(n1, n2)
    return `${min}` === `${stripX9(max)}`
  }

  return n1 === n2 || isEqualX9(n1, n2)
}

export const isTime = (value) => {
  return !time(value) ? "Horário inválido" : null
}

export const isPhone = (value) => {
  return !/^0\d{1,11}$/.test(value) ? "Número inválido" : null
}

export const isValidDate = (value) => {
  return !date(value) ? "Data inválida" : null
}

export const isValidUrl = (value) => {
  // eslint-disable-next-line no-useless-escape
  return !/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g.test(
    value
  )
    ? "Endereço do site inválido"
    : null
}

export const isValidEmail = (value) => {
  // eslint-disable-next-line no-useless-escape
  const regexEmail =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      value
    )
  return !regexEmail ? "E-mail inválido" : null
}

export const zipCode = (zipCode) => Mask.number(zipCode).length >= 8

function normalizeString(string) {
  return string
    .split("")
    .map(
      function (letter) {
        const i = this.accents.indexOf(letter)
        return i !== -1 ? this.out[i] : letter
      }.bind({
        accents:
          "ÀÁÂÃÄÅĄàáâãäåąßÒÓÔÕÕÖØÓòóôõöøóÈÉÊËĘèéêëęðÇĆçćÐÌÍÎÏìíîïÙÚÛÜùúûüÑŃñńŠŚšśŸÿýŽŻŹžżź",
        out: "AAAAAAAaaaaaaaBOOOOOOOOoooooooEEEEEeeeeeeCCccDIIIIiiiiUUUUuuuuNNnnSSssYyyZZZzzz"
      })
    )
    .join("")
}

export const isRequired = (value) =>
  _isEmpty(value) ? "Campo obrigatório" : null

export const removeAccents = normalizeString

export const cpf = pipe(safe, validarCPF)

export const username = usernameValidation

export const date = brazilianDateValidation

export const time = pipe(safe, timeValidation)

export const isEqualPhone = pipe(safe, isEqualPhoneValidation)

export const strongPasswordValidator = (password) => {
  const regexUpperCase = /[A-Z]/
  const regexLowerCase = /[a-z]/
  const regexNumber = /[0-9]/
  const regexSpecialChar = /[^A-Za-z0-9]/

  if (
    password.length >= 8 &&
    regexLowerCase.test(password) &&
    regexUpperCase.test(password) &&
    regexNumber.test(password) &&
    regexSpecialChar.test(password)
  ) {
    return true
  }

  return false
}

export const ensureArray = (variable) => {
  return Array.isArray(variable) ? variable : [variable]
}

export const validateProductName = (name) => {
  const isNumberRegex = /^\d+$/
  if (typeof name !== "string" || isNumberRegex.test(name) || _isEmpty(name)) {
    return "-"
  }
  return name.split(/(\d)/, 1)
}



// WEBPACK FOOTER //
// ./src/services/utils/validation.js